// extracted by mini-css-extract-plugin
module.exports = {"container":"user-access-management_container__2jB9s","header":"user-access-management_header__p7W3U","title":"user-access-management_title__12dYL"};